<template>
    <ConfirmDialog
        v-if="showPrompt"
        size="md"
        variant="primary"
        :custom-icon="RefreshIcon"
        :title="t('pwa.updateAvailable')"
        :message="t('pwa.updateDescription')"
        :confirm-text="isUpdating ? t('pwa.updating') : t('pwa.updateNow')"
        :cancel-text="t('pwa.updateLater')"
        :is-loading="isUpdating"
        @confirm="handleUpdate"
        @cancel="handleDismiss"
    />
</template>

<script setup lang="ts">
import ConfirmDialog from '@/components/ui/ConfirmDialog.vue';
import { useServiceWorker } from '@/composables/useServiceWorker';
import RefreshIcon from '@/icons/RefreshIcon.vue';
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const { state, update } = useServiceWorker();

const showPrompt = computed(() => state.value.isUpdateAvailable);
const showOfflineReady = ref(false);
const isUpdating = ref(false);

// Show offline ready notification temporarily
watch(
    () => state.value.isOfflineReady,
    (isReady) => {
        if (isReady) {
            showOfflineReady.value = true;
            setTimeout(() => {
                showOfflineReady.value = false;
            }, 5000);
        }
    },
);

const handleUpdate = async () => {
    try {
        isUpdating.value = true;
        await update();

        // Wait a moment for the service worker to activate
        setTimeout(() => {
            // Reload the page to activate the new service worker
            window.location.reload();
        }, 100);
    } catch (error) {
        console.error('Failed to update service worker:', error);
        isUpdating.value = false;
        // Optionally show error message to user
    }
};

const handleDismiss = () => {
    state.value.isUpdateAvailable = false;
};
</script>
